import { cn } from "@/shared/utils/cn"

export interface MediaProps {
  src: string
  alt?: string
  /** CSS aspect-ratio，如 "1 / 1"、"16 / 9" */
  ratio?: string
  rounded?: boolean
  className?: string
}

/** 图片展示：懒加载 + 可选固定比例 + 圆角 */
export function Media({ src, alt = "", ratio, rounded, className }: MediaProps) {
  return (
    <div
      className={cn("overflow-hidden", rounded && "rounded-card", className)}
      style={ratio ? { aspectRatio: ratio } : undefined}
    >
      <img src={src} alt={alt} loading="lazy" className="h-full w-full object-cover" />
    </div>
  )
}
